import { MapTo } from '@adobe/aem-react-editable-components';
import Tagfeed, { TagfeedEditConfig } from './Tagfeed';

export default MapTo('cob-corp-acquisition/components/creditonebank/tagfeed')(Tagfeed, TagfeedEditConfig);